import jQuery from 'jquery';

/* eslint-disable */

/* eslint-enable */
(function ($) {
  var ua = navigator.userAgent.toLowerCase();
  $(window).on({
    load: function () {
      if (ua.indexOf('iphone') > 0 || ua.indexOf('android') > 0) {
        $('.tel-link').each(function () {
          var str = $(this).text();
          $(this).html($('<a>').attr('href', 'tel:' + str.replace(/-/g, '')).append(str + '</a>'));
        });
      }

      if (ua.indexOf('iphone') > 0 || ua.indexOf('android') > 0) {
        $('.tel-link-img').each(function () {
          var telimg = $(this).children('img').prop('outerHTML');
          var str = $(this).children('img').attr('data-tel');
          $(this).html('<a href="tel:' + str + '">' + telimg + '</a>');
        });
      }
    }
  });

  /* アンカースクロール */
  $('a[href^="#"]').on('click', function () {
    var href = $(this).attr('href');
    var target = $(href === '#' || href === '' ? 'html' : href);
    var position = target.offset().top;
    $('body,html').animate({scrollTop: position}, 400, 'swing');
    return false;
  });

  /*
  * SPメニューの開閉
  */
  var scrTop;
  var $consultationImg = $('.consultation-img');
  $('#menu-btn').on('click', function () {
    $consultationImg.each(function () {
      if ($(window).innerWidth() >= 1220) {
        $(this).attr('src', $(this).attr('src').replace('_sp', '_pc'));
      } else {
        $(this).attr('src', $(this).attr('src').replace('_pc', '_sp'));
      }
    });

    var $this = $(this);
    if ($this.hasClass('open')) {
      scrTop = parseInt($('#page').css('top'));
      $('#site-navigation').fadeOut(300, function () {
        $this.removeClass('open');
      });
      $('#page').removeClass('content-fixed').css({top: 0});
      $(window).scrollTop(-scrTop);
      scrTop = '';
    } else {
      scrTop = $(window).scrollTop();
      $('#site-navigation').fadeIn(300, function () {
        $this.addClass('open');
      });
      $('#page').addClass('content-fixed').css({top: -scrTop});
    }
    return false;
  });

  $(window).on('resize', function () {
    $consultationImg.each(function () {
      if ($(window).innerWidth() >= 1220) {
        $(this).attr('src', $(this).attr('src').replace('_sp', '_pc'));
      } else {
        $(this).attr('src', $(this).attr('src').replace('_pc', '_sp'));
      }
    });
  });

  /*
  * 「ご来店の流れ」タブ切り替え
  */
  $('#flow-detail .flow-tab-title').on('click', function () {
    var $this = $(this);
    $('#flow-detail .flow-tab-wrap').not($this).removeClass('tab-active');
    $(this).parent('.flow-tab-wrap').addClass('tab-active');
  });
})(jQuery);



// WEBPACK FOOTER //
// ./src/js/original/common.js